var map = {
	"./sa/my-customer/edit.vue": [
		"fcb8",
		"bind-sa-recommend0~chatRoom0~chatRoom1~label-create0~label-create1~label-edit0~label-edit1~my-custom~6f7ca5b9",
		"my-customer-reservation-edit0"
	],
	"./sm/my-customer/edit.vue": [
		"921b",
		"bind-sa-recommend0~chatRoom0~chatRoom1~label-create0~label-create1~label-edit0~label-edit1~my-custom~6f7ca5b9",
		"my-customer-reservation-edit1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3972";
module.exports = webpackAsyncContext;